import React from 'react';
import { styled } from 'linaria/react';
import { css } from 'linaria';
import { Above, Below } from '@jetshop/ui/Breakpoints';
import { SearchBar } from './SearchBar';
import { Logo } from './Logo';

const LogoSearchBarWrapper = styled('div')`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  max-width: 100%;
  gap: 1rem;
`;

const DesktopSearchCSS = css`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
`;

function LogoSearchBar({ searchOpen, setSearchOpen }) {
  return (
    <LogoSearchBarWrapper>
      <Above breakpoint="md">
        <div className={DesktopSearchCSS}>
          <Logo />
          <SearchBar searchOpen={true} setSearchOpen={setSearchOpen} />
        </div>
      </Above>

      <Below breakpoint="md">
        {searchOpen ? (
          <SearchBar searchOpen={searchOpen} setSearchOpen={setSearchOpen} />
        ) : (
          <Logo searchOpen={searchOpen} />
        )}
      </Below>
    </LogoSearchBarWrapper>
  );
}

export { LogoSearchBar };
